import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getSitesCategoriesList(organizationId, sitesIds) {
    const params = {
      sites: sitesIds,
    }

    const url = `/api/v1/organizations/${organizationId}/categories/list/`
    return HTTP.get(url, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  getOrganizationCatalog(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/categories`
    return HTTP.get(url)
  },

  getOrganizationRules(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/settings/categories/rules`
    return HTTP.get(url)
  },

  createOrganizationRule(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/settings/categories/rules`
    return HTTP.post(url, data)
  },

  updateOrganizationRule(organizationId, ruleId, data) {
    const url = `/api/v1/organizations/${organizationId}/settings/categories/rules/${ruleId}`
    return HTTP.patch(url, data)
  },

  getSiteRules(organizationId, siteId) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/categories/rules`
    return HTTP.get(url)
  },

  createSiteRule(organizationId, siteId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/categories/rules`
    return HTTP.post(url, data)
  },

  updateSiteRule(organizationId, siteId, ruleId, data) {
    const url = `/api/v1/organizations/${organizationId}/sites/${siteId}/settings/categories/rules/${ruleId}`
    return HTTP.patch(url, data)
  },

  removeOrganizationRule(organizationId, ruleId) {
    const url = `/api/v1/organizations/${organizationId}/settings/categories/rules/${ruleId}`
    return HTTP.delete(url)
  },
}
